import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { RBHAlert, RBHBox } from "../../../../../../shared/components";
import { catCreators } from "../../../redux/cat-action";
import { AlertData, CAT_STATE_KEY, catStateSelector } from "../../../redux/cat-reducer";

export const AlertBar = () => {
    const dispatch = useDispatch();
    const alertSuccessData = useSelector(catStateSelector(CAT_STATE_KEY.ALERT_SUCCESS)) as AlertData;
    const alertSortSuccessData = useSelector(catStateSelector(CAT_STATE_KEY.ALERT_SORT_SUCCESS)) as AlertData;
    const alertFailureData = useSelector(catStateSelector(CAT_STATE_KEY.ALERT_FAILURE)) as AlertData;

    if (alertSortSuccessData?.isVisible) {
        return (
            <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
                <RBHAlert
                    type={'success'}
                    text={'main.cat_category.sort.alert.success'}
                    values={alertSortSuccessData?.translationValues}
                    autoCloseDuration={3000}
                    afterClose={() => {
                        dispatch(catCreators.setCatState(CAT_STATE_KEY.ALERT_SORT_SUCCESS, {
                            isVisible: false,
                        }));
                    }}
                />
                <br />
            </RBHBox>
        );
    }

    if (alertSuccessData?.isVisible) {
        return (
            <RBHBox id={'alertSuccess'} data-testid={'alertSuccess'}>
                <RBHAlert
                    type={'success'}
                    text={'main.cat_category.edit.alert.success'}
                    values={alertSuccessData?.translationValues}
                    autoCloseDuration={3000}
                    afterClose={() => {
                        dispatch(catCreators.setCatState(CAT_STATE_KEY.ALERT_SUCCESS, {
                            isVisible: false,
                            translationValues: {
                                categoryName: '???',
                            },
                        }));
                    }}
                />
                <br />
            </RBHBox>
        );
    }

    if (alertFailureData?.isVisible) {
        return (
            <RBHBox id={'alertFailure'} data-testid={'alertFailure'}>
                <RBHAlert
                    type={'error'}
                    text={'main.cat_category.edit.alert.failure'}
                    values={alertFailureData?.translationValues}
                    autoCloseDuration={3000}
                    afterClose={() => {
                        dispatch(catCreators.setCatState(CAT_STATE_KEY.ALERT_FAILURE, {
                            isVisible: false,
                            translationValues: {
                                categoryName: '???',
                            },
                        }));
                    }}
                />
                <br />
            </RBHBox>
        );
    }

    return null;
};